import { KeyValueModel } from "model/api";
import { EnumSubstituir } from "model/enums/enum-substituir";

export const TpSubstituidoMock: KeyValueModel[] = [
    new KeyValueModel(EnumSubstituir.NAO, "Não"),
    new KeyValueModel(EnumSubstituir.SIM, "Sim"),
];
